import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/opd.scss";
import { Button, Select, Row, Col, Input, InputNumber, Checkbox } from "antd";
import HeaderBar from "../../../components/header/headerBar";
import axios from "axios";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import PrintPage1 from "../detail/printPage1";
import PrintPage2 from "../detail/printPage2";
import moment from "moment";
import ReactToPrint from "react-to-print";

interface ParamTypes {
  id?: string;
  type?: string;
}

const PrintOPD = () => {
  const history = useHistory();

  const refPrintV1: any = useRef("pagePrintV1");
  const refPrintV2: any = useRef("pagePrintV2");
  const { id } = useParams<ParamTypes>();
  const [nameTitle, setNameTitle] = useState<string>("");
  const [checkPrintV1, setCheckPrintV1] = useState<boolean>(true);
  const [checkPrintV2, setCheckPrintV2] = useState<boolean>(false);
  const [dataPrint, setdataPrint] = useState<any>([]);
  const saveFormat = "YYYY-MM-DD";

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const getPersonal = async () => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      getPrefixes(res?.data);
      console.log("res?.data =>", res?.data);
    });
  };

  const getPrefixes = async (data: any) => {
    let prefix = "";
    let state = "";
    let city = "";
    let subCity = "";
    let postalCode = "";
    let gender = "";
    let contactsPrefix = "";
    let branch = "";

    let difference = moment().diff(data?.birthDate);
    let duration = moment.duration(difference);
    let year = duration.years();
    let day = duration.days();
    let month = duration.months();

    console.log("prefix", data);

    await axios.get(`/prefixes/${data?.prefix}`).then((res) => {
      prefix = res?.data?.name;
      console.log("prefixes", prefix);

      // setNameTitle(
      //   `${res?.data?.name}${data?.firstName} ${data?.lastName} (${data?.code})`
      // );
    });

    await axios.get(`/states/${data?.address?.state}`).then((res) => {
      state = res?.data?.name;
    });
    await axios.get(`/cities/${data?.address?.city}`).then((res) => {
      city = res?.data?.name;
    });
    await axios.get(`/sub-cities/${data?.address?.subCity}`).then((res) => {
      subCity = res?.data?.name;
    });
    await axios
      .get(`/postal-codes/${data?.address?.postalCode}`)
      .then((res) => {
        postalCode = res?.data?.name;
      });
    await axios.get(`/genders/${data?.gender}`).then((res) => {
      gender = res?.data?.name;
    });
    await axios
      .get(`/prefixes/${data?.emergencyContact?.prefix}`)
      .then((res) => {
        contactsPrefix = res?.data?.name;
      });
    await axios.get(`/branches/${data?.branch}`).then((res) => {
      branch = res?.data?.data?.name;
    });

    await setdataPrint({
      gender,
      branch,
      name: data?.firstName
        ? `${prefix} ${data?.firstName} ${data?.lastName}`
        : `${prefix} ${data?.firstNameEN} ${data?.lastNameEN}`,

      code: data?.code,
      nickName: data?.nickName,
      weight: data?.weight,
      height: data?.height,
      bloodtype: data?.bloodtype,
      idCard: data?.idCard,
      phoneNumbersFirst: data?.phoneNumbersFirst,
      phoneNumbersSecond: data?.phoneNumbersSecond,
      email: data?.email,
      contacts: `${contactsPrefix} ${data?.emergencyContact?.firstName} ${data?.emergencyContact?.lastName}`,
      contactsMobile: data?.emergencyContact?.phoneNumber,
      birthdate: moment(data?.birthDate).format(saveFormat),
      age: `${year} ปี ${day} วัน`,
      address: `${data?.address?.addressNumber} ${data?.address?.buildingName} 
                ${data?.address?.moo} ${data?.address?.soi}
                ${data?.address?.road}
                แขวน ${city} เขต ${subCity} ${state} ${postalCode}`,
      allergyHistory: data?.allergyHistory,
      underlyingDisease: data?.underlyingDisease,
    });
  };

  useEffect(() => {
    getPersonal();
    const memberId = query.get("memberId");
    const medicalRecordId = query.get("medicalRecordId");
    console.log("memberId", memberId);
  }, []);

  return (
    <div className="opd-custom-list">
      <HeaderBar title={`${nameTitle}`} btnBack={true}></HeaderBar>
      <div style={{ padding: "20px 40px" }}>
        <Row>
          <Col span={12} style={{ paddingRight: "15px" }}>
            <Row>
              <Col span={12} className="checkbox-custom">
                <Checkbox
                  checked={checkPrintV1}
                  autoFocus={true}
                  disabled={checkPrintV2 ? true : false}
                  onChange={(e: CheckboxChangeEvent) => {
                    setCheckPrintV1(e.target.checked);
                  }}
                >
                  เลือก Print
                </Checkbox>
              </Col>
              {/* <Col span={12} style={{ textAlign: "end" }} className="inputNumber-custom">
                จำนวน <span/>
                <InputNumber min={1} max={10} defaultValue={1} disabled={checkPrintV2 ? true : false}/>
              </Col> */}
            </Row>
            {console.log("dataPrint", dataPrint)}
            <PrintPage1 data={dataPrint} refPrint={refPrintV1} />
          </Col>
          <Col span={12} style={{ paddingLeft: "15px" }}>
            <Row>
              <Col span={12} className="checkbox-custom">
                <Checkbox
                  checked={checkPrintV2}
                  autoFocus={true}
                  disabled={checkPrintV1 ? true : false}
                  onChange={(e: CheckboxChangeEvent) => {
                    setCheckPrintV2(e.target.checked);
                  }}
                >
                  เลือก Print
                </Checkbox>
              </Col>
              {/* <Col span={12} style={{ textAlign: "end" }} className="inputNumber-custom">
                จำนวน <span/>
                <InputNumber min={1} max={10} defaultValue={1} disabled={checkPrintV1 ? true : false}/>
              </Col> */}
            </Row>

            <PrintPage2 data={dataPrint} refPrint={refPrintV2} />
          </Col>
        </Row>
      </div>
      <Row style={{ textAlign: "center", margin: "30px 0px" }}>
        <Col span={24}>
          <ReactToPrint
            trigger={() => <Button className="btn-print-sky">Print</Button>}
            content={() =>
              checkPrintV1
                ? refPrintV1?.current
                : checkPrintV2
                ? refPrintV2?.current
                : ""
            }
            bodyClass="print-custom-opd"
            pageStyle="@page { size: A4 portrait; }"
          />
        </Col>
      </Row>
    </div>
  );
};
export default PrintOPD;
